export namespace MineralWaterProperties {
  export type SourceTypeEnum = 'NATURAL' | 'ARTIFICIAL';
  export const SourceTypeEnum = {
    Natural: 'NATURAL' as SourceTypeEnum,
    Artificial: 'ARTIFICIAL' as SourceTypeEnum,
  };
  export type AcidityLevelEnum =
    | 'EXTRA_SPARKLING'
    | 'SPARKLING'
    | 'STILL'
    | 'MILD';
  export const AcidityLevelEnum = {
    ExtraSparkling: 'EXTRA_SPARKLING' as AcidityLevelEnum,
    Sparkling: 'SPARKLING' as AcidityLevelEnum,
    Still: 'STILL' as AcidityLevelEnum,
    Mild: 'MILD' as AcidityLevelEnum,
  };
}
